import {
	initAnimationScripts,
	initAlwaysRunScriptsChild,
	initParentScripts,
	initSliderScriptChild,
	initCustomScripts,
} from "./functions";

(() => {
	window.addEventListener("DOMContentLoaded", () => {
		initParentScripts();
		initAlwaysRunScriptsChild();
		initAnimationScripts();
		initSliderScriptChild();
		initCustomScripts();
	});
})();

// import WebGl from './webGl2/main';
// new WebGl('.js-webgl');
